<template>
    <li :class="{'active': section === active, dropdown: !url}">
        <router-link v-if="url" :to="url">
            {{ text }}
        </router-link>

        <a v-if="!url" href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">
            {{ text }} <span class="caret"></span>
        </a>

        <ul v-if="!url" class="dropdown-menu" role="menu">
            <li v-for="link in links" v-if="shouldDisplay(link)">
                <router-link :to="link.url">
                    {{ link.text }}
                </router-link>
            </li>
        </ul>
    </li>
</template>

<script>
    import Meta from '@/mixins/Meta'

    export default {
        mixins: [Meta],

        props: ['text', 'url', 'section', 'links'],

        computed: {
            active() {
                return this.getMeta('section')
            }
        },

        methods: {
            shouldDisplay(link) {
                return typeof link.display === 'undefined' || link.display
            }
        }
    }
</script>
